module.exports = __webpack_public_path__ + "static/media/ini3-180w.58da5206.jpg";